import { memo } from 'react'

import { PhotoCameraIcon } from '../../../../components/Icons'
import { Heading } from '../Heading'

interface ImageValidationErrorProps {
  imageUrl: string
  onClose: () => void
  errorMessage?: string
}

const ImageValidationError: React.FC<ImageValidationErrorProps> = memo(
  ({ imageUrl, onClose, errorMessage }) => {
    return (
      <>
        <Heading
          title="Review Your Photo"
          subtitle={
            <>
              Review your photo and ensure it’s a medium shot with upper torso
              visible, looking straight at camera, head level, centered and well
              lit.
            </>
          }
        />
        <div className="rounded-2xl aspect-video w-[750px] max-w-full mx-auto relative mb-auto sm:mb-0">
          <img
            src={imageUrl}
            alt="Preview"
            className="h-full w-full object-cover rounded-2xl aspect-video"
          />

          <div className="absolute inset-0 flex items-center justify-center">
            <div className="rounded-lg p-6 max-w-md mx-4 text-center bg-white bg-opacity-70 backdrop-blur-xl">
              <div className="flex items-center justify-center mb-4">
                <i className="fa-solid fa-exclamation-triangle text-[#D62B04] text-2xl mr-3" />
                <div className="text-center">
                  <div className="text-[#D62B04] font-segoe text-xl font-normal leading-[150%]">
                    {errorMessage ||
                      'Image validation failed. Please try again.'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center gap-4 flex-wrap mt-8">
          <button
            data-testid="image-validation-error-change-photo-btn"
            className="btn btn-primary"
            onClick={onClose}
          >
            <PhotoCameraIcon size={16} />
            <span className="ml-2">Change Photo</span>
          </button>
        </div>
      </>
    )
  },
)

ImageValidationError.displayName = 'ImageValidationError'

export { ImageValidationError }
